import React, { useEffect, useState } from "react";
import LabelWithInput from "@components/input/LabelWithInput";
import DropdownInput from "@components/input/DropdownInput";
import { ConditionDrawer } from "@pages/register/_components/index";
import styled from "@emotion/styled";
import Switch from "@components/item/Switch";
import { useFormContext } from "react-hook-form";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const BrokenWrapper = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.4rem",
  padding: "1.6rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2rem",
  backgroundColor: theme.color.border_gray,
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
}));

const Condition = ({ conditionRef }: { conditionRef?: any }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const {
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { getConditionList } = useApiRequest();

  const { data: conditionList } = useQuery({
    queryKey: ["conditionList"],
    queryFn: getConditionList,
  });

  const handleOpenDrawer = () => {
    setOpenDropdown(false);
    setOpenDrawer(true);
  };

  const is_damaged = watch("is_damaged");
  const product_condition = watch("product_condition");

  const toggleBroken = () => {
    if (is_damaged === 0) {
      setValue("is_damaged", 1);
    } else {
      setValue("is_damaged", 0);
    }
  };

  useEffect(() => {
    if (product_condition) {
      trigger("product_condition");
    }
  }, [product_condition, trigger]);

  return (
    <Container ref={conditionRef}>
      <LabelWithInput
        label="컨디션"
        required
        notice
        notiOnClick={handleOpenDrawer}>
        <DropdownInput
          options={conditionList}
          name="product_condition"
          open={openDropdown}
          setOpen={setOpenDropdown}
        />
      </LabelWithInput>

      <BrokenWrapper>
        <span>{"하자가 있는 경우에는 체크해주세요."}</span>
        <Switch toggleEvent={toggleBroken} checked={is_damaged === 1} />
      </BrokenWrapper>

      <ConditionDrawer open={openDrawer} setOpen={setOpenDrawer} />
      {errors?.product_condition && (
        <ErrorMessage>
          {errors?.product_condition.message?.toString()}
        </ErrorMessage>
      )}
    </Container>
  );
};

export default Condition;
